export default __webpack_public_path__ + "static/media/GlassComputer.f9f310f6.svg";